import {React, useEffect, useState} from "react";
import { Form, Container, Row, Col } from "react-bootstrap";
import InputField from "../InputField/InputField";
import SlectInputField from "../SlectInputField/SlectInputField";
import * as Yup from "yup";
import RASelect from 'react-select/async';
import { Formik } from "formik";
import "./CorporateSignUp.styles.css";
import { Flip, Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { userRegistration ,commonPost, commonGet} from "../../services/auth";
import { useNavigate } from 'react-router-dom';
import Axios from '../../lib/axios/axiosInstance';
import {BASE_AUTH_URL,BASE_URL} from '../../lib/constant'
import CustomDateTimePicker from '../InputField/CustomDateTimePicker';

const CorporateSignUp = () => {
  const navigate = useNavigate();
  const [staffnums, setStaffnums] = useState();
  const [dob, setDob] = useState(new Date());
  const [initialValue, setInitialValue] = useState({
    fName: "",
    lName: "",
    gender: "",
    dob: "",
    email: "",
    password: "",
    cpassword: "",
    companyname: "",
    uenno: "",
    address: "",
    city: "SG",
    state: "SG",
    postalcode: "",
    country: 'SG',
    contactno: "",
    address1:"",
    website: "",
    uploadFile: '',
    staffnum :""
  });

  const CorporateformSchema = Yup.object().shape({
    fName: Yup.string().min(2).max(25).required("First name is required"),
    lName: Yup.string().min(2).max(25).required("Last name is required"),
    gender: Yup.string().required("Gender is required"),
    username: Yup.string().min(6).required("Username is required"),
    email: Yup.string().email("Email is invalid").required("Email is required"),
    password: Yup.string().required("Password is required"),
    cpassword: Yup.string().required("confirm password is required").oneOf([Yup.ref("password"), null], "Passwords must match"),
    companyname: Yup.string().required("Company name is required"),
    staffnum: Yup.string().required("Company Strength is required"),
    uenno: Yup.string().required("UEN No. is required"),
    address: Yup.string().max(200).required("Address is required"),
    country: Yup.string().required('Country is required'),
    // city: Yup.string().required("City is required"),
    // state: Yup.string().required("State is required"),
    contactno: Yup.string().min(8).required("Please enter your contact number"),
    website: Yup.string(),
    uploadFile: Yup.string()
  });

  const signUpFormSubmitHandler = async (values) => {
    const url = "accounts/register"
    const selectedStaff=staffnums.filter(x=>x.value==values.staffnum)[0];
    await checkUenno(values.uenno).then(async result=>{
      if(result.data){
        toast.warning('UEN No. already used. Please use another UEN No.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
          transition: Slide,
        });
        return false;
      }else{
        const val = {
          firstname: values.fName,
          lastname: values.lName,
          gender: values.gender,
          dob: dob,
          roletype: "Corporate",
          email: values.email,
          username: values.username,
          password: values.password,
          confirmpassword: values.cpassword,
          arname: values.companyname,
          uenno: values.uenno,
          addr1: addValue,//values.address,
          addr2: values.address,
          city: cityValue,
          postcode: postValue,//.substring(2,a.length),//values.postalcode.toString(),
          area: postValue.substring(0, 2),//values.postalcode.toString(),
          state: stateValue,//values.state,
          country: countryValue,
          mobile: values.contactno.toString(),
          phone: values.contactno.toString(),
          website: values.website,
          uploadacra: values.uploadFile,
          acceptTerms: true,
          staffnum:values.staffnum,
          staffqtynum :selectedStaff.varid
        };
        // console.log(val);
        await userRegistration(val, url).then(response=>{
          if (response && response.status == 200) {
            toast.success('Registration Successful. Please click on the link sent in the email to verify your account.', {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
              transition: Slide,
            });
            navigate('/login');
          }
          else if (response && response.status == 202) {
            toast.warning('Email Already Registered. Please use another email or check your mail for more details.', {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 5000,
              transition: Slide,
            });
          }
          else if(response.message){
            toast.error(response.message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 5000,
              transition: Slide,
            });
          }
          else {
            toast.error('Something went Wrong!', {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
              transition: Flip,
            })
          }
        })
      }
    });
    
  }
  toast.configure();
  
  const [countries, setCountries] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [countryValue, setCountryValue] = useState('Singapore');
  const [allStates, setAllStates] = useState([]);
  const [states, setStates] = useState([]);
  const [stateValue, setStateValue] = useState('Singapore');
  const [cityValue, setCityValue] = useState('Singapore');
  const [allCities, setAllCities] = useState([]);
  const [cities, setCities] = useState([]);
  const [addValue, setAddValue] = useState('');
  const [addValueChange, setAddValueChange] = useState('');
  const [postValue, setPostValue] = useState('');
  const [defaultValue, setDefaultValue] = useState(true);

  const checkUenno = async (value) => {
    return await commonPost(null,`${BASE_AUTH_URL}/accounts/check-uenno/${value}`,true);
  };

  const getCountries = async () => {
    var allCountries = await commonGet(null,`https://devb2b.bizpoint-intl.com:3082/api/sysvar/countryList`,true);
    var dd=[];
    setAllCountries(allCountries.data.countryList);
    allCountries.data.countryList.forEach(element => {
        dd.push({ label: element.grp.varname, value:  element.grp.varid})
    });
    setCountries(dd);
  };

  async function handleCountryChange(event){
    var result=allCountries.filter(x=>x.grp.varid==event.target.value)[0];
    var dd=[];
    if(result.subgrp.length>0){
      setAllStates(result.subgrp);
      result.subgrp.forEach(element => {
        dd.push({ label: element.grp.varname, value:  element.grp.varid})
     });
    }
    setStates(dd);
    setCities([]);
    if(!defaultValue)
    setCountryValue(countries.filter(x=>x.value==event.target.value)[0]?.label);
  }

  async function handleStateChange(event){
    var result=allStates.filter(x=>x.grp.varid==event.target.value)[0];
    var dd=[];
    setAllCities(result);
    result.subgrp.forEach(element => {
      dd.push({ label: element.grp.varname, value:  element.grp.varid})
    });
    setCities(dd);
    if(!defaultValue)
    setStateValue(states.filter(x=>x.value==event.target.value)[0]?.label);
  }

  async function handleCityChange(event){
    setCityValue(cities.filter(x=>x.value==event.target.value)[0]?.label);
  }

  useEffect(async () => {
    getCountries();
    // Register account (B2B)
    // https://devb2b.bizpoint-intl.com:3082/api/sysvar/staffStrength
    await Axios.get(`/sysvar/staffStrength`)
    .then(function (response) {
        if (response && response.data?.staffStrength) {
          var data =[]
          response.data?.staffStrength.forEach(item=>{
            data.push({label: item.grp.varname, value: item.grp.varvalue, varid:item.grp.varid})
          })
          setStaffnums(data);
        }
        else {
          setStaffnums([]);
        }
    })
    .catch(function (error) {
      setStaffnums([]);
    });
  }, [])

  useEffect(async () => {
    if(defaultValue && allCountries.length>0){
      handleCountryChange({target:{value:"SG"}});
    }
  }, [allCountries])

  useEffect(async () => {
    if(defaultValue && allStates.length>0){
      handleStateChange({target:{value:"SG"}});
      setDefaultValue(false);
    }
  }, [allStates])
  
  function handlePostalChange(event){
    const postalDiv = event.label.split(' ');
    var postCode="00";
    for (let index = 0; index < postalDiv.length; index++) {
      if(Number(postalDiv[index])>0){
        postCode=postalDiv[index];
      }
    }
    setPostValue(postCode);
    setAddValue(event.value);
    setAddValueChange(event.value);
  }

  useEffect(async () => {
    if(addValue){
      window.setPostalCode(addValue);
    }
  }, [addValue])

  const filterPostalCodes = async (inputValue) => {
    var result = await commonGet(null,`https://developers.onemap.sg/commonapi/search?searchVal=${inputValue}&returnGeom=Y&getAddrDetails=Y&pageNum=1`,true);
    var dd=[];
    if(result.data.results && result.data.results.length >0){
      result.data.results.forEach(element => {
        dd.push({ label: element.SEARCHVAL +"\n"+element.ADDRESS, value:  element.ADDRESS})
    });
    }
    return dd.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };
  
  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      if(inputValue.length>1){
        setTimeout(() => {
          resolve(filterPostalCodes(inputValue));
        }, 1000);
      }
  });

  return (
    <>
      <section className="main-container col1-layout">
        <Container className="main">
          <div className="account-login">
            <div className="page-title">
              <h2>Corporate Sign Up</h2>
            </div>
            <Formik
              initialValues={initialValue}
              validationSchema={CorporateformSchema}
              validate={(values) => {
                let errors = {};
                if (!dob) {
                  errors.dob = "Date of birth is required.";
                }
                if(addValue==''){
                  errors.address1 = "Address 1 is required";
                }
                else if(addValue.length>150){
                  errors.address1 = "Address 1 must be at most 150 characters";
                }
                return errors;
              }}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                if(!postValue){
                  toast.warning('Please enter your zip/postal code !', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Flip,
                  });
                  return false;
                }
                signUpFormSubmitHandler(values)
                // resetForm()
                setSubmitting(false);
              }}
              enableReinitialize
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isValid,
                isSubmitting,
                setFieldValue,
              }) => (
                <form noValidate onSubmit={handleSubmit}>
                  <fieldset className="col1-set">
                    {/* <!-- <div className="col-1 new-users"><strong>New Customers</strong>
                <div className="content">
                  <p>By creating an account with our store, you will be able to move through the checkout process faster, store multiple shipping addresses, view and track your orders in your account and more.</p>
                  <div className="buttons-set">
                    <button onclick="window.location='http://demo.magentojtv.com/computerstore/customer/account/create/';" className="button create-account" type="button"><span>Create an Account</span></button>
                  </div>
                </div>
              </div> --> */}
                    <div className="col-1 registered-users">
                      <strong>Account Information</strong>
                      <div className="content">
                        <p>
                          Please ensure your details are complete and accurate.
                          Your profile details will be used as your default
                          billing information on checkout process.
                        </p>
                        <hr />
                        <div className="form-list">
                          <Row>
                          <Col sm={6}>
                              <InputField
                                Name="username"
                                id="username"
                                Labels="Username"
                                Type="text"
                                value={values.useranme}
                                onChange={handleChange}
                                isInvalid={!!errors.useranme}
                                className={(errors.useranme && touched.useranme) ? 'is-invalid' : 'form-control'}
                              // onBlur={handleBlur}
                              //errors={errors.email && touched.email && errors.email}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={6}>
                              <InputField
                                Name="password"
                                id="password"
                                Labels="Password"
                                Type="password"
                                value={values.password}
                                onChange={handleChange}
                                isInvalid={!!errors.password}
                                className={(errors.password && touched.password) ? 'is-invalid' : 'form-control'}

                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={6}>
                              <InputField
                                Name="cpassword"
                                id="cpassword"
                                Type="password"
                                value={values.cpassword}
                                onChange={handleChange}
                                Labels="Confirm Password"
                                isInvalid={!!errors.cpassword}
                                className={(errors.cpassword && touched.cpassword) ? 'is-invalid' : 'form-control'}

                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                    <hr />
                    <fieldset className="col1-set">
                      {/* <!-- <div className="col-1 new-users"><strong>New Customers</strong>
                          <div className="content">
                            <p>By creating an account with our store, you will be able to move through the checkout process faster, store multiple shipping addresses, view and track your orders in your account and more.</p>
                            <div className="buttons-set">
                              <button onclick="window.location='http://demo.magentojtv.com/computerstore/customer/account/create/';" className="button create-account" type="button"><span>Create an Account</span></button>
                            </div>
                          </div>
                        </div> --> */}
                      <div className="col-1 registered-users">
                        <strong>Personal Information</strong>
                        <div className="content">
                          <br />
                          <div className="form-list">
                            <Row>
                              <Col sm={6}>
                                <InputField
                                  Labels="First Name"
                                  Type="text"
                                  Name="fName"
                                  value={values.fName}
                                  onChange={e=>{handleChange(e)}}
                                  onBlur={handleBlur}
                                  className={
                                    "form-control" +
                                    (errors.fName && touched.fName
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </Col>
                              <Col sm={6}>
                                <InputField
                                  Labels="Last Name"
                                  Type="text"
                                  Name="lName"
                                  value={values.lName}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={
                                    "form-control" +
                                    (errors.lName && touched.lName
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </Col>
                            </Row>
                            <Row>
                            <Col sm={6}>
                              <InputField
                                Name="email"
                                id="email"
                                Labels="Email Address"
                                Type="text"
                                value={values.email}
                                onChange={handleChange}
                                isInvalid={!!errors.email}
                                className={(errors.email && touched.email) ? 'is-invalid' : 'form-control'}
                              // onBlur={handleBlur}
                              //errors={errors.email && touched.email && errors.email}
                              />
                            </Col>
                              <Col sm={6}>
                                {/* <InputField
                                  Labels="Date of Birth"
                                  Type="date"
                                  Name="dob"
                                  value={values.dob}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={
                                    "form-control" +
                                    (errors.dob && touched.dob
                                      ? " is-invalid"
                                      : "")
                                  }
                                /> */}
                                <CustomDateTimePicker 
                                  Labels="Date of Birth"
                                  startYear={1970}
                                  value={new Date(dob)}
                                  onChange={(e)=>{handleChange({type:"change",target:{value:e}}); setDob(e);}}
                                  className={(errors.dob && touched.dob ) ? 'is-invalid' : 'form-control'}
                                />
                              </Col>
                            </Row>
                            <Row>
                              
                            <Col sm={6}>
                                <label>Gender</label>
                                <br />
                                <label style={{ paddingRight: "5px" }}>
                                  <input
                                    type="radio"
                                    name="gender"
                                    value="Male"
                                    checked={values.gender === "Male"}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  Male
                                </label>
                                <label>
                                  <input
                                    type="radio"
                                    name="gender"
                                    value="Female"
                                    checked={values.gender === "Female"}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  Female
                                </label>
                                {errors.gender && touched.gender ? (
                                  <>
                                    <span
                                      style={{
                                        color: "red",
                                        paddingLeft: "20px",
                                      }}
                                    >
                                      {" ! "} {errors.gender}{" "}
                                    </span>
                                    <br />
                                  </>
                                ) : (
                                  ""
                                )}
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  <hr />
                  <fieldset className="col1-set">
                    <div className="col-1 registered-users">
                      <strong>Company Information</strong>
                      <div className="content">
                        <br />
                        <div className="form-list">
                          <Row>
                            <Col sm={6}>
                              <InputField
                                Name="companyname"
                                id="companyname"
                                value={values.companyname}
                                onChange={handleChange}
                                Labels="Company Name"
                                Type="text"
                                isInvalid={!!errors.companyname}
                                className={(errors.companyname && touched.companyname) ? 'is-invalid' : 'form-control'}

                              />
                            </Col>
                            <Col sm={6}>
                              <InputField
                                Name="uenno"
                                id="uenno"
                                value={values.uenno}
                                onChange={handleChange}
                                Type="text"
                                Labels="UEN No."
                                isInvalid={!!errors.uenno}
                                className={(errors.uenno && touched.uenno) ? 'is-invalid' : 'form-control'}

                              />
                            </Col>
                            <Col sm={6}>
                            <SlectInputField
                                  Labels="Company Strength"
                                  Name="staffnum"
                                  placeHolder="Select Your Strength"
                                  options={staffnums}
                                  value={values.staffnum}
                                  onChange={e=>{handleChange(e); }}
                                  onBlur={handleBlur}
                                  className={
                                    (errors.staffnum && touched.staffnum
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={6}>
                              <h5>Billing Details</h5>
                              <br />
                            </Col>
                          </Row>
                          <Row>
                            
                            <Col sm={6}>
                              <InputField
                                Name="contactno"
                                id="contactno"
                                value={values.contactno}
                                onChange={handleChange}
                                Type="number"
                                Labels="Contact No."
                                isInvalid={!!errors.contactno}
                                className={(errors.contactno && touched.contactno) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>
                         
                            <Col sm={6}>
                                <div className="custom_select">
                                  <label>Zip / Postal Code</label>
                                  <RASelect
                                    classNamePrefix="lp-copy-sel customPostalCodeSelect "
                                    defaultOptions 
                                    cacheOptions 
                                    onChange={e=>{handlePostalChange(e); handleChange(e.label);}}
                                    onBlur={handleBlur}
                                    loadOptions={promiseOptions}
                                    className={
                                      (errors.zipCode && touched.zipCode
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>
                          
                          <Row>
                            
                            
                            <Col sm={6}>
                              <InputField
                                Name="address1"
                                value={addValue}
                                onChange={e=>{handleChange(e); setAddValue(e.target.value)}}
                                Type="text"
                                Labels="Address 1"
                                className={
                                  "form-control" +
                                  (errors.address1 && touched.address1
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                            </Col>

                            <Col sm={6}>
                                <InputField
                                  Labels="Address 2"
                                  Type="text"
                                  Name="address"
                                  value={values.address}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={
                                    "form-control" +
                                    (errors.address && touched.address
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </Col>
                            </Row>
                            <Row>
                            <Col sm={6}>
                              <div className="custom_select">
                                <SlectInputField
                                  Labels="Country"
                                  Name="country"
                                  placeHolder="Select Your Country"
                                  options={countries}
                                  value={values.country}
                                  onChange={e=>{values.state=""; setStates([]); values.city=""; setCities([]); handleCountryChange(e); handleChange(e); }}
                                  onBlur={handleBlur}
                                  className={
                                    (errors.country && touched.country
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </div>
                            </Col>
                            <Col sm={6}>
                              <InputField
                                Name="website"
                                id="website"
                                value={values.website}
                                onChange={handleChange}
                                Type="text"
                                Labels="Website"
                                isInvalid={!!errors.website}
                                className={(errors.country && touched.website) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>
                            {/* <Col sm={6}>
                              <div className="custom_select">
                                <SlectInputField
                                  Labels="State/Province"
                                  Type="text"
                                  Name="state"
                                  placeHolder="Select Your State"
                                  options={states}
                                  value={values.state}
                                  onChange={e=>{handleStateChange(e); handleChange(e);}}
                                  onBlur={handleBlur}
                                  className={
                                    (errors.state && touched.state
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </div>
                            </Col> */}
                            </Row>
                            {/* <Row>
                            <Col sm={6}>
                              <div className="custom_select">
                                <SlectInputField
                                  Name="city"
                                  id="city"
                                  placeHolder="Please Select City"
                                  value={values.city}
                                  options={cities}
                                  onChange={e=>{handleCityChange(e); handleChange(e);}}
                                  onBlur={handleBlur}
                                  Type="text"
                                  Labels="City"
                                  isInvalid={!!errors.city}
                                  className={(errors.city && touched.city) ? 'is-invalid' : ''}
                                />
                              </div>
                            </Col>
                            </Row> */}
                          <hr />
                          <Row>
                            <Col sm={6}>
                              <InputField
                                Labels="Upload ACRA (Optional)"
                                Type="text"
                                //Type="file"
                                Name="uploadFile"
                                value={values.uploadFile}
                                onChange={handleChange}
                              />
                              <button
                                className="button"
                                style={{ background: "#ddd" }}
                              >
                                Browse
                              </button>
                            </Col>
                          </Row>
                          <hr />
                          <Row>
                            <label>
                              <strong>
                                By providing my information, I acknowledge and
                                accept the terms of Pacific eShop
                                <a href="">Privacy Policy</a> and
                                <a href="">Terms of Service</a>
                              </strong>
                            </label>
                            <br />
                          </Row>
                        </div>
                        <br />
                        <div className="buttons-set">
                          <button
                            id="send2"
                            name="send"
                            type="submit"
                            className="button login"
                          >
                            <span>Register</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </form>
              )}
            </Formik>
          </div>
        </Container>
      </section>
    </>
  );
};

export default CorporateSignUp;
